import { render } from "./icon-check.vue?vue&type=template&id=a669f31c"
import script from "./icon-check.vue?vue&type=script&lang=js"
export * from "./icon-check.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__